import { render } from "./MachinesList.vue?vue&type=template&id=65278db8"
import script from "./MachinesList.vue?vue&type=script&lang=js"
export * from "./MachinesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__